export const INITIALIZE = "INITIALIZE"
export const PURCHASE = "PURCHASE"
export const READ = "READ"
export const SET_TAX = "SET_TAX"
export const PURCHASED = "PURCHASED"
